<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import EquimentsCategory from "./equipment/EquimentsCategory.vue";
import EquimentsRadioButton from "./equipment/EquimentsRadioButton.vue";
import dottedArrow from "../../../../static/assets/images/dotted-arrow.svg";
import kettlebells from "../../../../static/assets/images/kettlebells.svg";
import mattress from "../../../../static/assets/images/mattress.svg";
import resistanceBand from "../../../../static/assets/images/resistance-band.svg";
import slider from "../../../../static/assets/images/slider.svg";
import bench from "../../../../static/assets/images/bench.svg";
import towel from "../../../../static/assets/images/towel.svg";
import otherWeights from "../../../../static/assets/images/other-weights.svg";
import roller from "../../../../static/assets/images/roller.svg";
import other from "../../../../static/assets/images/other.svg";
export default {
  components: { EquimentsCategory, EquimentsRadioButton },
  name: "EquipmentTab",
  data() {
    return {
      dottedArrow,
      equipment: null,
      activeEquipments: [],
      radioOpions: [
        { text: "No", value: "no" },
        { text: "Optional", value: "optional" },
        { text: "Required", value: "required" },
      ],
      icons: [
        kettlebells,
        mattress,
        resistanceBand,
        slider,
        bench,
        towel,
        otherWeights,
        roller,
        other,
      ],
    };
  },
  computed: {
    sidebar() {
      return this.$store.getters[`${this.currentType}/sidebarOpened`];
    },
    equipmentsCategories() {
      return this.$store.getters[`${this.currentType}/equipmentsCategories`];
    },
    currentEquipment() {
      return this.$store.getters[`${this.currentType}/currentEquipment`];
    },
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    selectedEquipments() {
      return this.$store.getters[`${this.currentType}/selectedEquipments`];
    },
    with_equipment: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "with_equipment",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.with_equipment;
        }
        return "";
      },
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
  },
  mounted() {
    this.$store.dispatch(`${this.currentType}/getEquipmentsCategories`);
  },
  methods: {
    save: function () {
      this.$store.commit("commons/setPreloader", true);
      const currentEquipment = this.currentEquipment;
      const selectedData = this.activeEquipments.map(function (value, key) {
        if (currentEquipment) {
          return currentEquipment && currentEquipment.equipments
            ? currentEquipment.equipments.find(
                (equipment) => equipment.id == key
              )
            : null;
        }
      });

      this.$store
        .dispatch(`${this.currentType}/createSelectedEquipments`, selectedData)
        .then((res) => {
          this.$store.commit(`commons/setSavingForm`, "Saved");
          this.closeSidebar();
          this.$store.commit("commons/setPreloader", false);
        });
    },
    // Close sidebar
    closeSidebar: function () {
      this.$store.dispatch(`${this.currentType}/closeSidebar`);
      setTimeout(() => {
        this.$store.commit(`workouts/setTabStatus`, false);
      }, 2000);
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    updateActivity() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("workouts/updateActivity", this.$route.params.id)
        .then((res) => {
          this.$store.commit(`commons/setSavingForm`, "Saved");
          setTimeout(() => {
            this.$store.commit(`workouts/setTabStatus`, false);
            this.$store.commit("commons/setPreloader", false);
          }, 2000);
        });
    },
    deleteEquipment(id) {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("workouts/deleteSelectedEquipment", id)
        .then((res) => {
          this.$store.commit(`commons/setSavingForm`, "Removed");
          setTimeout(() => {
            this.$store.commit(`workouts/setTabStatus`, false);
            this.$store.commit("commons/setPreloader", false);
          }, 2000);
        });
    },
  },
};
</script>

<style lang="scss">
.sidebar-equipments {
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1000;
  .close {
    color: #fff;
    display: block;
    position: fixed;
    top: 10px;
    left: 20px;
    svg {
      font-size: 40px;
    }
  }

  .content {
    width: 860px;
    max-width: 90%;
    background: #fff;
    float: right;
    height: 100%;
    overflow-y: auto;

    .choices-wrapper {
      border: 1px solid #e3e3e3;
      border-radius: 4px;
      padding: 20px;
      margin-bottom: 10px;

      p {
        margin: 0;
        color: #767676;
        font-size: 15px;
      }
    }
  }
}

.equipments-content {
  width: calc(100% - 590px);
  padding-right: 3rem !important;
  p {
    color: rgba(0, 0, 0, 0.4);
    font-size: 13px;
  }
}

.equipments-selected {
  overflow: auto;
  height: 100%;
  width: 370px;
  box-shadow: -4px 10px 8px #00000014;
  position: absolute;
  z-index: 1;
  background: #fafafb;
  right: 0;
  top: 0;
  padding: 40px 30px;

  h4 {
    font-size: 15px;
    margin-top: 20px;
  }

  table {
    font-size: 14px;
    td {
      text-align: center;
      width: 50%;
      &:first-child {
        text-align: left;
      }
      &:last-child {
        text-align: right;
      }
    }
  }
}

.no-equipment {
  position: relative;
  padding-top: 20px;

  img {
    top: -120px;
    position: absolute;
    left: 35%;
  }
}
</style>

<template>
  <div class="px-5 py-5">
    <div class="d-flex">
      <b-form-group class="pr-5" style="width: 260px">
        <div class="radio-wrapper">
          <input
            type="radio"
            id="noEquipment"
            name="equipment"
            value="false"
            v-model="with_equipment"
            v-on:change="updateActivity"
          />
          <label for="noEquipment">
            <span>
              <div class="check"></div>
            </span>
            No Equipment
          </label>
        </div>

        <div class="radio-wrapper">
          <input
            type="radio"
            id="withEquipment"
            name="equipment"
            value="true"
            v-model="with_equipment"
            v-on:change="updateActivity"
          />
          <label for="withEquipment">
            <span>
              <div class="check"></div>
            </span>
            With Equipment
          </label>
        </div>
      </b-form-group>
      <div
        v-if="
          currentActivity.with_equipment == true ||
          currentActivity.with_equipment == 'true'
        "
        class="equipments-content"
      >
        <h3 class="mb-4">
          Please select below the equipment for this workout:
        </h3>
        <div class="row text-center mt-3">
          <equiments-category
            v-for="equipment in equipmentsCategories"
            :key="equipment.id"
            :equipment="equipment"
          >
          </equiments-category>
        </div>
      </div>

      <div
        v-if="
          currentActivity.with_equipment == true ||
          currentActivity.with_equipment == 'true'
        "
        class="equipments-selected"
      >
        <h3 class="mb-4">Selected equipment</h3>
        <p v-if="!selectedEquipments"><i>No equipment selected yet...</i></p>

        <div v-for="equipment in selectedEquipments" :key="equipment.id">
          <div v-if="equipment.selected.length">
            <h4>{{ equipment.label }}</h4>
            <table class="w-100">
              <div v-for="selected in equipment.selected" :key="selected.id">
                <tr>
                  <td>{{ selected.label }}</td>
                  <td>{{ selected.selected_option }}</td>
                  <td class="text-danger">
                    <b-icon
                      icon="trash"
                      aria-hidden="true"
                      @click="deleteEquipment(selected.id)"
                      class="cursor-pointer"
                    ></b-icon>
                  </td>
                </tr>
              </div>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-center no-equipment"
      v-if="currentActivity.with_equipment == null"
    >
      <img :src="dottedArrow" />
      <h2>Let us know if equipment are necessary or not</h2>
      <p>Start selecting an answer.</p>
    </div>
    <div class="sidebar-equipments" v-if="sidebar">
      <span class="close cursor-pointer" @click="closeSidebar()"
        ><b-icon icon="x"
      /></span>
      <div class="content px-5 py-5" v-if="currentEquipment">
        <div class="d-flex align-items-center mb-2">
          <img :src="icons[currentEquipment.id - 1]" />
          <h2 class="mb-0 pl-2">Select {{ currentEquipment.label }}</h2>
        </div>
        <p>({{ currentEquipment.selected.length }} Selected)</p>
        <b-form class="mt-5">
          <div
            class="choices-wrapper d-flex justify-content-between"
            v-for="data in currentEquipment.equipments"
            :key="data.id"
          >
            <p>{{ data.label }}</p>
            <div class="d-flex ml-3">
              <b-form-radio-group v-model="data.selected_option">
                <!-- <b-form-radio value="no" v-model="activeEquipments[data.id]">
                  No
                </b-form-radio> -->
                <b-form-radio
                  value="optional"
                  v-model="activeEquipments[data.id]"
                  :checked="
                    currentEquipment.selected &&
                    currentEquipment.selected_option == 'optional'
                      ? 1
                      : 0
                  "
                  >Optional</b-form-radio
                >
                <b-form-radio
                  value="required"
                  v-model="activeEquipments[data.id]"
                  :checked="
                    currentEquipment.selected &&
                    currentEquipment.selected_option == 'required'
                      ? 1
                      : 0
                  "
                  >Required</b-form-radio
                >
              </b-form-radio-group>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-5">
            <b-button variant="" class="mr-2 px-4 py-3" @click="closeSidebar()"
              >CANCEL</b-button
            >
            <b-button variant="primary" class="px-4 py-3" @click="save()"
              >SAVE</b-button
            >
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>